/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityTypesActivities } from '../../models/activity-types-activities';

export interface ActivityTypesById$Params {

/**
 * Profile id.
 */
  profileId: number;
}

export function activityTypesById(http: HttpClient, rootUrl: string, params: ActivityTypesById$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityTypesActivities>>> {
  const rb = new RequestBuilder(rootUrl, activityTypesById.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityTypesActivities>>;
    })
  );
}

activityTypesById.PATH = '/rest/profile/{profileId}/activity-types';
